export const REPAYMENT_NOT_POSSIBLE_MODAL = 'REPAYMENT_NOT_POSSIBLE_MODAL';

export const MEMBERSHIP_ALREADY_RENEWED_WARNING_CODE =
  'MembershipAlreadyRenewed';
